// frontend/src/components/common/Input.jsx
// COMPONENTE INPUT REUTILIZABLE
import React from 'react';
import styled from 'styled-components';

// CONTAINER DEL CAMPO
// Reducimos el margin-bottom por defecto para filas más compactas
const FieldContainer = styled.div`
  margin-bottom: ${({ $noMargin }) => ($noMargin ? '0' : '0.5rem')};
`;

// LABEL DEL CAMPO
const Label = styled.label`
  display: block;
  margin-bottom: 0.15rem;
  color: ${({ theme }) => theme.colors.txtPrincipal};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  font-size: 0.875rem;
`;

// INPUT ESTILIZADO
const StyledInput = styled.input`
  width: 100%;
  padding: ${({ $size }) => ($size === 'sm' ? '0.3rem 0.5rem' : '0.4rem 0.6rem')};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.txtPrincipal};
  font-size: ${({ $size }) => ($size === 'sm' ? '0.8rem' : '0.875rem')};
  transition: all 0.2s ease;
  min-height: ${({ $size }) => ($size === 'sm' ? '30px' : '34px')};
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary}20;
  }
  
  &:disabled {
    background: ${({ theme }) => theme.colors.surfaceDisabled};
    color: ${({ theme }) => theme.colors.txtSecondary};
    cursor: not-allowed;
  }
  
  &.error {
    border-color: ${({ theme }) => theme.colors.danger};
  }
`;

// MENSAJE DE ERROR
const ErrorMessage = styled.span`
  display: block;
  margin-top: 0.25rem;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.75rem;
`;

// COMPONENTE INPUT
const Input = ({ 
  label, 
  error, 
  type = 'text', 
  className,
  noMargin,
  size,
  ...props 
}) => {
  return (
    <FieldContainer $noMargin={noMargin}>
      {label && <Label>{label}</Label>}
      <StyledInput 
        type={type}
        className={error ? 'error' : className}
        $size={size}
        {...props}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FieldContainer>
  );
};

export default Input;
